export default __webpack_public_path__ + "static/media/web.03fa1878.svg";